import { Injectable } from '@angular/core';
import { assign, cloneDeep } from 'lodash-es';
import { CoreInternalApiService } from '@core/lib/internal-api';
import { user as userData } from 'app/core/data/user/data';

@Injectable({
    providedIn: 'root'
})
export class UserInternalApi
{
    private _user: any = userData;

    /**
     * Constructor
     */
    constructor(private _coreInternalApiService: CoreInternalApiService)
    {
        // Register Internal API handlers
        this.registerHandlers();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register Internal API handlers
     */
    registerHandlers(): void
    {
        // -----------------------------------------------------------------------------------------------------
        // @ User - GET
        // -----------------------------------------------------------------------------------------------------
        this._coreInternalApiService
            .onGet('api/common/user')
            .reply(() => [200, cloneDeep(this._user)]);

        // -----------------------------------------------------------------------------------------------------
        // @ User - PATCH
        // -----------------------------------------------------------------------------------------------------
        this._coreInternalApiService
            .onPatch('api/common/user')
            .reply(({request}) => {

                // Get the user internal-api
                const user = cloneDeep(request.body.user);

                // Update the user internal-api
                this._user = assign({}, this._user, user);

                // Return the response
                return [200, cloneDeep(this._user)];
            });
    }
}
